function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
//
// ## Description
// `StemmableNote` is an abstract interface for notes with optional stems.
// Examples of stemmable notes are `StaveNote` and `TabNote`
import { Vex } from './vex';
import { Flow } from './tables';
import { Stem } from './stem';
import { Glyph } from './glyph';
import { Note } from './note';
export var StemmableNote = /*#__PURE__*/function (_Note) {
  _inherits(StemmableNote, _Note);

  var _super = _createSuper(StemmableNote);

  function StemmableNote(note_struct) {
    var _this;

    _classCallCheck(this, StemmableNote);

    _this = _super.call(this, note_struct);

    _this.setAttribute('type', 'StemmableNote');

    _this.stem = null;
    _this.stemExtensionOverride = null;
    _this.beam = null;
    return _this;
  } // Get and set the note's `Stem`


  _createClass(StemmableNote, [{
    key: "getStem",
    value: function getStem() {
      return this.stem;
    }
  }, {
    key: "setStem",
    value: function setStem(stem) {
      this.stem = stem;
      return this;
    } // Builds and sets a new stem

  }, {
    key: "buildStem",
    value: function buildStem() {
      var stem = new Stem();
      this.setStem(stem);
      return this;
    }
  }, {
    key: "buildFlag",
    value: function buildFlag() {
      var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'flag';
      var glyph = this.glyph,
          beam = this.beam;
      var shouldRenderFlag = beam === null;

      if (glyph && glyph.flag && shouldRenderFlag) {
        var flagCode = this.getStemDirection() === Stem.DOWN ? glyph.code_flag_downstem : glyph.code_flag_upstem;
        this.flag = new Glyph(flagCode, this.render_options.glyph_font_scale, {
          category: category
        });
      }
    } // Get the custom glyph associated with the outer note head on the base of the stem.

  }, {
    key: "getBaseCustomNoteHeadGlyph",
    value: function getBaseCustomNoteHeadGlyph() {
      if (this.getStemDirection() === Stem.DOWN) {
        return this.customGlyphs[this.customGlyphs.length - 1];
      } else {
        return this.customGlyphs[0];
      }
    } // Get the full length of stem

  }, {
    key: "getStemLength",
    value: function getStemLength() {
      return Stem.HEIGHT + this.getStemExtension();
    } // Get the number of beams for this duration

  }, {
    key: "getBeamCount",
    value: function getBeamCount() {
      var glyph = this.getGlyph();

      if (glyph) {
        return glyph.beam_count;
      } else {
        return 0;
      }
    } // Get the minimum length of stem

  }, {
    key: "getStemMinumumLength",
    value: function getStemMinumumLength() {
      var frac = Flow.durationToFraction(this.duration);
      var length = frac.value() <= 1 ? 0 : 20; // if note is flagged, cannot shorten beam

      switch (this.duration) {
        case '8':
          if (this.beam == null) length = 35;
          break;

        case '16':
          length = this.beam == null ? 35 : 25;
          break;

        case '32':
          length = this.beam == null ? 45 : 35;
          break;

        case '64':
          length = this.beam == null ? 50 : 40;
          break;

        case '128':
          length = this.beam == null ? 55 : 45;
          break;

        default:
          break;
      }

      return length;
    } // Get/set the direction of the stem

  }, {
    key: "getStemDirection",
    value: function getStemDirection() {
      return this.stem_direction;
    }
  }, {
    key: "setStemDirection",
    value: function setStemDirection(direction) {
      if (!direction) direction = Stem.UP;

      if (direction !== Stem.UP && direction !== Stem.DOWN) {
        throw new Vex.RERR('BadArgument', "Invalid stem direction: ".concat(direction));
      }

      this.stem_direction = direction;

      if (this.stem) {
        this.stem.setDirection(direction);
        this.stem.setExtension(this.getStemExtension()); // Lookup the base custom notehead (closest to the base of the stem) to extend or shorten
        // the stem appropriately. If there's no custom note head, lookup the standard notehead.

        var glyph = this.getBaseCustomNoteHeadGlyph() || this.getGlyph(); // Get the font-specific customizations for the note heads.

        var offsets = this.musicFont.lookupMetric("stem.noteHead.".concat(glyph.code_head), {
          offsetYBaseStemUp: 0,
          offsetYTopStemUp: 0,
          offsetYBaseStemDown: 0,
          offsetYTopStemDown: 0
        }); // Configure the stem to use these offsets.

        this.stem.setOptions({
          stem_up_y_offset: offsets.offsetYTopStemUp,
          // glyph.stem_up_y_offset,
          stem_down_y_offset: offsets.offsetYTopStemDown,
          // glyph.stem_down_y_offset,
          stem_up_y_base_offset: offsets.offsetYBaseStemUp,
          // glyph.stem_up_y_base_offset,
          stem_down_y_base_offset: offsets.offsetYBaseStemDown // glyph.stem_down_y_base_offset,

        });
      } // Reset and reformat everything.


      this.reset();

      if (this.flag) {
        this.buildFlag();
      }

      this.beam = null;

      if (this.preFormatted) {
        this.preFormat();
      }

      return this;
    } // Get the `x` coordinate of the stem

  }, {
    key: "getStemX",
    value: function getStemX() {
      var x_begin = this.getAbsoluteX() + this.x_shift;
      var x_end = this.getAbsoluteX() + this.x_shift + this.getGlyphWidth();
      var stem_x = this.stem_direction === Stem.DOWN ? x_begin : x_end;
      return stem_x;
    } // Get the `x` coordinate for the center of the glyph.
    // Used for `TabNote` stems and stemlets over rests

  }, {
    key: "getCenterGlyphX",
    value: function getCenterGlyphX() {
      return this.getAbsoluteX() + this.x_shift + this.getGlyphWidth() / 2;
    } // Get the stem extension for the current duration

  }, {
    key: "getStemExtension",
    value: function getStemExtension() {
      var glyph = this.getGlyph();

      if (this.stemExtensionOverride != null) {
        return this.stemExtensionOverride;
      }

      if (glyph) {
        return this.getStemDirection() === 1 ? glyph.stem_up_extension : glyph.stem_down_extension;
      }

      return 0;
    } // Set the stem length to a specific. Will override the default length.

  }, {
    key: "setStemLength",
    value: function setStemLength(height) {
      this.stemExtensionOverride = height - Stem.HEIGHT;
      return this;
    } // Get the top and bottom `y` values of the stem.

  }, {
    key: "getStemExtents",
    value: function getStemExtents() {
      return this.stem.getExtents();
    } // Sets the current note's beam

  }, {
    key: "setBeam",
    value: function setBeam(beam) {
      this.beam = beam;
      return this;
    } // Get the `y` value for the top/bottom modifiers at a specific `textLine`

  }, {
    key: "getYForTopText",
    value: function getYForTopText(textLine) {
      var extents = this.getStemExtents();

      if (this.hasStem()) {
        return Math.min(this.stave.getYForTopText(textLine), extents.topY - this.render_options.annotation_spacing * (textLine + 1));
      } else {
        return this.stave.getYForTopText(textLine);
      }
    }
  }, {
    key: "getYForBottomText",
    value: function getYForBottomText(textLine) {
      var extents = this.getStemExtents();

      if (this.hasStem()) {
        return Math.max(this.stave.getYForTopText(textLine), extents.baseY + this.render_options.annotation_spacing * textLine);
      } else {
        return this.stave.getYForBottomText(textLine);
      }
    }
  }, {
    key: "hasFlag",
    value: function hasFlag() {
      return Flow.getGlyphProps(this.duration).flag && !this.beam;
    } // Post format the note

  }, {
    key: "postFormat",
    value: function postFormat() {
      if (this.beam) this.beam.postFormat();
      this.postFormatted = true;
      return this;
    } // Render the stem onto the canvas

  }, {
    key: "drawStem",
    value: function drawStem(stem_struct) {
      this.checkContext();
      this.setRendered();
      this.setStem(new Stem(stem_struct));
      this.stem.setContext(this.context).draw();
    }
  }]);

  return StemmableNote;
}(Note);